import type { TFunction } from 'i18next';

/**
 * Traduz o nome dos temas.
 *
 * Eles nascem escritos em inglês em `style/theme.tsx` (`Light`, `Dark`,
 * `Midnight`, `System default`) e não passam pelo i18n — por isso apareciam
 * em inglês no seletor mesmo com o app em português.
 *
 * Traduzir aqui, e não no objeto `themes`, mantém `Themes.test.tsx` do
 * upstream passando: ele casa pelo nome `Light`, e os testes rodam com o
 * i18next em inglês, onde `t()` devolve a própria chave.
 *
 * ⚠️ Tema personalizado instalado pelo dono NUNCA é traduzido — o nome é dele.
 */
const PADROES = new Set(['Light', 'Dark', 'Midnight', 'System default']);

export function nomeDeTema(t: TFunction, nome: string): string {
  return PADROES.has(nome) ? t(nome) : nome;
}
